import { render } from "./DotQueHalfScreenTile.vue?vue&type=template&id=619be318&scoped=true&ts=true"
import script from "./DotQueHalfScreenTile.vue?vue&type=script&lang=ts"
export * from "./DotQueHalfScreenTile.vue?vue&type=script&lang=ts"

import "./DotQueHalfScreenTile.vue?vue&type=style&index=0&id=619be318&lang=less"
import "./DotQueHalfScreenTile.vue?vue&type=style&index=1&id=619be318&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619be318"]])

export default __exports__